"use client";

import { useState } from "react";
import Navbar from "../Navbar/Navbar";
import Sidebar from "../SIdeBar/SIdeBar";
import Footer from "../Footer/Footer";
import CampusNavbar from "@/components/campusComponent/CampusNavbar/page";
import { usePathname } from "next/navigation";


function Layout({ children }: { children: React.ReactNode }) {
  const [sidebar, openSidebar] = useState<boolean>(false);
  const [sidebarPosition, setSidebarPosition] = useState<"left" | "right">("right");

  const pathname = usePathname(); // get current route

  const isCampusRoute = pathname.startsWith("/events") || pathname.startsWith("/alumni");

  return (
    <div className="flex flex-col min-h-screen">
      {/* overflow-x-hidden */}
      {/* {pathname === "/" && <CurtainScreen />} */}
      <header className=" bg-white z-40 relative  top-0">
        {isCampusRoute ? (
          <CampusNavbar openSidebar={() => openSidebar((prev) => !prev)} sidebar={sidebar} />
        ) : (
           <Navbar
            openSidebar={() => openSidebar((prev) => !prev)}
            sidebar={sidebar}
            setSidebarPosition={setSidebarPosition}
          />
        )}
      </header>
      <main className=" font-poppins flex-grow">
        <div className="lg:hidden">
          <Sidebar
            openSidebar={() => openSidebar((prev) => !prev)}
            sidebar={sidebar}
            position={sidebarPosition}
          />
        </div>
        <div
          onClick={() => {
            if (sidebar) {
              openSidebar(false);
            }
          }}
        >
          {children}
        </div>
      </main>
      <Footer />
    </div>
  );
}
export default Layout;
